<div class="error-title-container">
  <h1 [translate]="'ErrorPageComponent:Title'">Sorry, we can't find the page you're looking for</h1>
  <h2 [innerHTML]="'ErrorPageComponent:SubTitle' | translate">
    Please select the relevant module below or visit our <a href="contact">Contact</a> page:
  </h2>
</div>

<section>
  <div class="error-module-inline">
    <div class="error-module-container">
      <div
        class="error-module-block travel-block"
        tabindex="0"
        role="link"
        (click)="navigate('travel')"
        (keyup.enter)="navigate('travel')"
        (keyup.space)="navigate('travel')"
        *ngIf="(siteSettings$ | async)?.switches.travel_module"
      >
        <span [translate]="'GlobalNav:NavTravel'"></span>
      </div>

      <div
        class="error-module-block dining-block"
        tabindex="0"
        role="link"
        (click)="navigate('dining')"
        (keyup.enter)="navigate('dining')"
        (keyup.space)="navigate('dining')"
        *ngIf="(siteSettings$ | async)?.switches.dining_module"
      >
        <span [translate]="'GlobalNav:NavDining'"></span>
      </div>

      <div
        class="error-module-block entertainment-block"
        tabindex="0"
        role="link"
        (click)="navigate('entertainment')"
        (keyup.enter)="navigate('entertainment')"
        (keyup.space)="navigate('entertainment')"
        *ngIf="(siteSettings$ | async)?.switches.entertainment_module"
      >
        <span [translate]="'GlobalNav:NavEntertainment'"></span>
      </div>

      <div
        class="error-module-block events-block"
        tabindex="0"
        role="link"
        (click)="navigate('member-events')"
        (keyup.enter)="navigate('member-events')"
        (keyup.space)="navigate('member-events')"
        *ngIf="(siteSettings$ | async)?.switches.member_events_module"
      >
        <span [translate]="'GlobalNav:NavEvents'"></span>
      </div>

      <div
        class="error-module-block offers-block"
        tabindex="0"
        role="link"
        (click)="navigate('member-benefits')"
        (keyup.enter)="navigate('member-benefits')"
        (keyup.space)="navigate('member-benefits')"
        *ngIf="(siteSettings$ | async)?.switches.member_benefits_module"
      >
        <span [translate]="'GlobalNav:NavOffers'"></span>
      </div>
    </div>
  </div>
</section>
